import {Data, Int, RecordProps} from '@store/@types/util';
import dayjs, {Dayjs} from 'dayjs';
import getFullName from 'utils/getFullName';

interface WelcomeEmailUserProps {
  readonly id: string;
  readonly color: string;
  readonly avatar?: string;
  readonly email: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly remindersSent: Int;
  readonly lastEmailed?: Dayjs;
  readonly hasLoggedIn: boolean;
  readonly displayName: string;
}

export default class WelcomeEmailUser extends Data<WelcomeEmailUserProps>({
  id: undefined,
  color: undefined,
  avatar: undefined,
  email: undefined,
  firstName: undefined,
  lastName: undefined,
  remindersSent: undefined,
  lastEmailed: undefined,
  hasLoggedIn: undefined,
  displayName: undefined,
}) {
  constructor(props: RecordProps<WelcomeEmailUserProps>) {
    super({
      ...props,
      lastEmailed: dayjs(props.lastEmailed),
      displayName: getFullName(props),
    });
  }
}
